import React from 'react'
import { Link } from 'react-router-dom';

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import peopleGreenIcon from "./../../../../assets/img/DashboardICons/peopleGreenIcon.svg";

const StaffColleaguesInfoNotif = () => {
    return (
        <div dir="rtl" className={`mt-3 pt-2 mx-4 px-2 d-flex justify-content-between`}>
            <div className={`p-3 w-100 d-flex align-items-center justify-content-start ${styles.total_staff_colleagues_notif_box}`}>
                <img className={`${styles.icon_staff_colleagues_notif_box}`} src={peopleGreenIcon} alt="people-green-icon" />
                <h3 className={`pe-4 text-right mb-0 ${styles.title_staff_colleagues_notif_box}`}>
                    درخواست های مشاور
                </h3>
                <Link to={"/staff-managment-colleagues-info-notif-detail"} style={{ color: "#21409a" }} className={`me-auto`}>
                    مشاهده
                    <img className="p-2" src={arrowBlue} alt="arrow-left-blue" width="29" />
                </Link>
            </div>
        </div>
    )
}

export default StaffColleaguesInfoNotif